import { render, staticRenderFns } from "./TaxiVehicleCard.vue?vue&type=template&id=611a9b32&scoped=true"
import script from "./TaxiVehicleCard.vue?vue&type=script&lang=js"
export * from "./TaxiVehicleCard.vue?vue&type=script&lang=js"
import style0 from "./TaxiVehicleCard.vue?vue&type=style&index=0&id=611a9b32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "611a9b32",
  null
  
)

export default component.exports